
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/timeline/articles",
      function () {
        return require("private-next-pages/timeline/articles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/timeline/articles"])
      });
    }
  